import { investmentDashboardSuccessType } from "./actionTypes"

export const fetchInvestmentDashBoardData = payload => ({
  type: investmentDashboardSuccessType,
  payload
  });